import { useState } from "react";
import ModalPopup from "../../../../../shared/components/modals/custom-popup";
import DataDisplay from "../../../transaction-certificates/tc-components/tc-error-detail-panel";
import { CustomButton } from "../../../../../shared/components/buttons/buttons";

export const RejectReasonCell = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const rejectionReasons = Array.isArray(row.original.rejectionReason)
        ? row.original.rejectionReason
        : [row.original.rejectionReason];

    return (
        <>
            {Array.isArray(row.original.rejectionReason) ? (
                <>
                    <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Show Reason" onClick={handleOpen}>
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Rejection Reason">
                        <DataDisplay data={rejectionReasons} />
                    </ModalPopup>
                </>
            ) : (
                <span>{row.original.rejectionReason}</span>
            )}
        </>
    );
};